import React, { useCallback } from 'react';
import { createPlugin } from 'react-plugin';
import { FixtureSelectProvider } from './FixtureSelectContext.js';
import { FixtureTreeContainer } from './FixtureTreeContainer.js';
import { revealFixture } from './revealFixture.js';
import { getTreeExpansion, setTreeExpansion } from './shared.js';
const { namedPlug, register } = createPlugin({
    name: 'fixtureTree',
    methods: {
        revealFixture,
    },
});
namedPlug('navPanelRow', 'fixtureTree', ({ pluginContext }) => {
    const { getMethodsOf } = pluginContext;
    const storage = pluginContext.getMethodsOf('storage');
    const router = getMethodsOf('router');
    const core = getMethodsOf('core');
    const rendererCore = getMethodsOf('rendererCore');
    const root = getMethodsOf('root');
    const { fixturesDir, fixtureFileSuffix } = core.getFixtureFileVars();
    const expansion = getTreeExpansion(storage);
    const setExpansionMemo = useCallback((newExpansion) => setTreeExpansion(storage, newExpansion), [storage]);
    const handleFixtureSelect = useCallback((fixtureId, multiFixtureOpen) => {
        router.selectFixture(fixtureId);
        if (!multiFixtureOpen && root.drawerPanelsEnabled())
            root.closeNavPanel();
    }, [root, router]);
    return (React.createElement(FixtureSelectProvider, { onSelect: handleFixtureSelect },
        React.createElement(FixtureTreeContainer, { fixturesDir: fixturesDir, fixtureFileSuffix: fixtureFileSuffix, selectedFixtureId: router.getSelectedFixtureId(), fixtures: rendererCore.getFixtures(), expansion: expansion, setExpansion: setExpansionMemo })));
});
export { register };
if (process.env.NODE_ENV !== 'test')
    register();
